
import React from "react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Edit, Trash2, Clock } from "lucide-react";
import { MessageProps } from "./types";

export const ChatMessage: React.FC<MessageProps> = ({
  message,
  formatTimestamp,
  getInitials,
  getMessageClasses,
  onEdit,
  onDelete,
  isCurrentUser,
  editingMessage,
  editText,
  setEditText,
  setEditingMessage
}) => {
  return (
    <div key={message.id} className="flex flex-col gap-1">
      <div className="flex items-start gap-3">
        <Avatar className="h-8 w-8">
          <AvatarFallback>{getInitials(message.user_name)}</AvatarFallback>
        </Avatar>
        
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <span className="font-medium text-sm">
              {isCurrentUser ? `${message.user_name} (jij)` : message.user_name}
            </span>
            <span className="text-xs text-gray-500 flex items-center">
              <Clock className="h-3 w-3 mr-1" />
              {formatTimestamp(message.created_at)}
            </span>
          </div>
          
          {editingMessage === message.id ? (
            <div className="flex flex-col gap-2">
              <Textarea 
                value={editText} 
                onChange={(e) => setEditText(e.target.value)}
                className="min-h-[60px]"
              />
              <div className="flex gap-2">
                <Button size="sm" onClick={() => onEdit(message.id, editText)}>
                  Opslaan
                </Button>
                <Button 
                  size="sm" 
                  variant="outline" 
                  onClick={() => {
                    setEditingMessage(null);
                    setEditText("");
                  }}
                >
                  Annuleren
                </Button>
              </div>
            </div>
          ) : (
            <div className={getMessageClasses(message)}>
              <p>{message.message}</p>
              {message.is_edited && !message.is_deleted && (
                <span className="text-xs text-gray-500 block mt-1">
                  (bewerkt op {formatTimestamp(message.updated_at)})
                </span>
              )}
            </div>
          )}
        </div>
        
        {isCurrentUser && 
         !message.is_deleted && 
         editingMessage !== message.id && (
          <div className="flex gap-1 ml-2">
            <Button 
              variant="ghost" 
              size="icon" 
              className="h-7 w-7" 
              onClick={() => {
                setEditingMessage(message.id);
                setEditText(message.message);
              }}
            >
              <Edit className="h-4 w-4 text-gray-500" />
            </Button>
            <Button 
              variant="ghost" 
              size="icon" 
              className="h-7 w-7" 
              onClick={() => onDelete(message.id)}
            >
              <Trash2 className="h-4 w-4 text-gray-500" />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
